module.exports = __webpack_public_path__ + "static/media/39.7e750f61.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/39.png
// module id = 1000
// module chunks = 0